import { render, staticRenderFns } from "./ContextCard.vue?vue&type=template&id=f835142c&scoped=true"
import script from "./ContextCard.vue?vue&type=script&lang=js"
export * from "./ContextCard.vue?vue&type=script&lang=js"
import style0 from "./ContextCard.vue?vue&type=style&index=0&id=f835142c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f835142c",
  null
  
)

export default component.exports